import { setData } from "rivals/shared/utils/qa";

function Spotify({ episodeId }: { episodeId: string }): JSX.Element {
  return (
    <iframe
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
      allowFullScreen
      height="232"
      loading="lazy"
      src={`https://open.spotify.com/embed/episode/${episodeId}?utm_source=generator`}
      style={{ border: 0, borderRadius: 12 }}
      title={`template-spotify-${episodeId}`}
      width="100%"
      {...setData("template-spotify", episodeId)}
    />
  );
}

export default Spotify;
